// ReportsModal.jsx
import { useEffect } from "react";
import { useReports } from "../context/ReportsContext";
import { BROKER_NAME, CLIENT_ID } from "../../../utils/constants";
import ReportsSkeleton from "../components/ReportsSkeleton";
import UnlockedReports from "../components/UnlockedReports";
import LockedReports from "../components/LockedReports";

const ReportsModal = ({ isOpen, onClose }) => {
  const {
    loading,
    error,
    eligibility,
    reports,
    fetchEligibility,
    fetchReports,
  } = useReports();

  useEffect(() => {
    const initializeReports = async () => {
      try {
        const currentuser_id = BROKER_NAME === "gmail" ? "gmail" : CLIENT_ID;
        if (!currentuser_id) return;

        const eligibilityData = await fetchEligibility(currentuser_id);
        if (eligibilityData.showReports) {
          await fetchReports(currentuser_id);
        }
      } catch (err) {
        console.error("Reports initialization error:", err);
      }
    };

    if (isOpen) {
      initializeReports();
    }
  }, [isOpen, BROKER_NAME, fetchEligibility, fetchReports, CLIENT_ID]);

  const renderContent = () => {
    if (loading && !eligibility && !reports) {
      return <ReportsSkeleton />;
    }

    if (error) {
      return (
        <div className="flex items-center justify-center p-4 text-red-500">
          {error}
        </div>
      );
    }

    if (reports) {
      return <UnlockedReports />;
    }

    if (eligibility) {
      return <LockedReports />;
    }

    return (
      <div className="flex items-center justify-center p-4">
        Something went wrong, please try again later.
      </div>
    );
  };

  return (
    <div className={`modal ${isOpen ? "modal-open" : ""}`}>
      <div className="modal-box w-2/4 bg-modalBg">
        <button
          onClick={onClose}
          className="btn btn-sm btn-circle absolute right-4 top-6">
          ✕
        </button>
        {/* <h3 className="font-bold text-lg mb-4">Reports</h3> */}
        <div className="flex flex-col h-full overflow-hidden">
          {renderContent()}
        </div>
      </div>
      <div className="modal-backdrop" onClick={onClose}></div>
    </div>
  );
};

export default ReportsModal;
